let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("28LiP")).then(() => parcelRequire('1qaHq'));